<p-selectButton
  [options]="
    isBoolean === true
      ? [
          { label: ('Enabled' | translate), value: true },
          { label: ('Disabled' | translate), value: false },
        ]
      : (items ?? [])
  "
  [(ngModel)]="value"
  (ngModelChange)="valueChange.emit(value)"
  [name]="key ?? ''"
  [multiple]="type === 'checkbox'"
  [disabled]="disabled"
  [class]="class"
  [class.btn-group-detached]="detached"
  [class.btn-group-expanded]="expanded"
  optionLabel="label"
  optionValue="value"
>
  <ng-template let-item pTemplate="item">
    <div class="select-button-content" [pTooltip]="item.tooltipLabel">
      <div
        *ngIf="!!item.logo"
        class="logo"
        [ngStyle]="{ 'background-image': 'url(' + item.logo + ')' }"
      ></div>
      <i *ngIf="!!item.icon" class="icon {{ item.icon }}"></i>
      <span>{{ item.label }}</span>
    </div>
  </ng-template>
</p-selectButton>
